import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const CHANGE_REFINEMENT_REASON = NS + 'CHANGE_REFINEMENT_REASON'

export const GET_REFINEMENT_REASON_REQUEST = NS + 'GET_REFINEMENT_REASON_REQUEST'
export const GET_REFINEMENT_REASON_SUCCESS = NS + 'GET_REFINEMENT_REASON_SUCCESS'
export const GET_REFINEMENT_REASON_ERROR = NS + 'GET_REFINEMENT_REASON__ERROR'

export const SAVE_REFINEMENT_REASON_REQUEST = NS + 'SAVE_REFINEMENT_REASON_REQUEST'
export const SAVE_REFINEMENT_REASON_SUCCESS = NS + 'SAVE_REFINEMENT_REASON_SUCCESS'
export const SAVE_REFINEMENT_REASON_ERROR = NS + 'SAVE_REFINEMENT_REASON__ERROR'




// WEBPACK FOOTER //
// ./src/modules/refinement/state/type.js